import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-login-required-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="lrd">
      <h2 mat-dialog-title class="lrd__title">Sign in required</h2>
      <mat-dialog-content class="lrd__body">
        <p>Sign in with your Google account to download mindmaps and study material.</p>
      </mat-dialog-content>
      <mat-dialog-actions align="end" class="lrd__actions">
        <button mat-button type="button" (click)="ref.close(false)">Not now</button>
        <button mat-flat-button color="primary" type="button" (click)="goToLogin()">Sign in</button>
      </mat-dialog-actions>
    </div>
  `,
  styles: [`
    .lrd { min-width: 280px; max-width: 420px; padding: var(--space-2); }
    .lrd__title { font-size: var(--fs-lg) !important; font-weight: var(--fw-semibold) !important; color: var(--color-text-primary); }
    .lrd__body { color: var(--color-text-secondary); }
    .lrd__body p { font-size: var(--fs-base); line-height: var(--lh-base); }
    .lrd__actions { padding: var(--space-3) 0 0 0; }
  `]
})
export class LoginRequiredDialogComponent {
  ref = inject<MatDialogRef<LoginRequiredDialogComponent, boolean>>(MatDialogRef);
  private router = inject(Router);

  goToLogin(): void {
    const returnTo = window.location.pathname + window.location.search;
    this.ref.close(true);
    this.router.navigate(['/login'], { queryParams: { returnTo } });
  }
}
